<p-autocomplete [ngModel]="displayValue()" (ngModelChange)="onModelChange($event)" [suggestions]="filteredPeriodicals()"
    (completeMethod)="searchPeriodicals($event)" (onSelect)="onSelect($event)" [dropdown]="true" dropdownMode="current"
    [forceSelection]="false" [minLength]="minLength" [placeholder]="placeholder()" [disabled]="disabled()"
    styleClass="w-full text-sm">
    <ng-template let-item pTemplate="item">
        <div class="flex flex-col">
            <span class="font-medium">{{item.name}}</span>
            <span *ngIf="item.id && item.name" class="text-xs text-gray-500">{{item.id}}</span>
        </div>
    </ng-template>
</p-autocomplete>
